import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ReactDateTimePicker from 'react-datetime-picker';
import Label from '../Label';
import './datepicker-overrides.css';
var DateTimePicker = function (_a) {
    var label = _a.label, format = _a.format, value = _a.value, onChange = _a.onChange, minDate = _a.minDate, maxDate = _a.maxDate;
    return _jsxs("div", { children: [_jsx(Label, { label: label }), _jsx(ReactDateTimePicker, { value: value, onChange: onChange, disableClock: true, format: format, minDate: minDate, maxDate: maxDate })] });
};
export default DateTimePicker;
